import React, { useState } from "react";
import PropTypes from "prop-types";

import { Row, Col, Button } from "react-bootstrap";
import Formsy from "formsy-react";
import { Textarea, Checkbox } from "formsy-react-components";
import { IoPeople, IoPerson, IoEye, IoEyeOff } from "react-icons/io5";
import DropdownSearch from "../common/DropdownSearch";
import DateTimePicker from "../common/DateTimePicker";
import CustomToggle from "../common/Toggle";

const HolidayForm = ({
  inputs,
  onChange,
  defaultData,
  onChangeDate,
  usersToggle,
  onSubmit,
  saving,
  displayUsers,
  individualHoliday,
  toggleIndividualHoliday,
  selectedUsers
}) => {
  const [allowSubmit, setAllowSubmit] = useState(false);
  return (
    <Formsy
      className="vertical form"
      onValidSubmit={onSubmit}
      onValid={() => setAllowSubmit(true)}
      onInvalid={() => setAllowSubmit(false)}
    >
      <Row>
        <Col md={12} xs={12}>
          <fieldset>
            <legend>Holiday Details</legend>
          </fieldset>
        </Col>
        <Col md={4} xs={12}>
          <DropdownSearch
            required
            disabled
            name="customer"
            label="Customer"
            onChange={onChange}
            data={defaultData?.customers?.map((customer) => ({
              value: customer._id,
              label: customer.name
            }))}
            value={inputs?.customer}
          />
        </Col>
        <Col md={4} xs={12}>
          <DropdownSearch
            name="project"
            label="Project"
            onChange={onChange}
            disabled
            data={defaultData?.projects?.map((project) => ({
              value: project._id,
              label: project.name
            }))}
            value={inputs?.project}
          />
        </Col>
        <Col md={4} xs={12}>
          <DropdownSearch
            name="call_type"
            label="Call Type"
            disabled
            data={defaultData?.call_types?.map((code) => ({
              value: code._id,
              label: code.label
            }))}
            value={inputs?.call_type}
          />
        </Col>
        <Col md={4} xs={12}>
          <DropdownSearch
            name="department"
            label="Department"
            disabled
            data={defaultData?.departments?.map((d) => ({
              value: d._id,
              label: d.description
            }))}
            value={inputs?.department}
          />
        </Col>
        <Col md={4} xs={12}>
          <DropdownSearch
            name="stage"
            label="Status"
            disabled
            onChange={onChange}
            data={defaultData?.stages?.map((code) => ({
              value: code._id,
              label: code.label
            }))}
            value={inputs?.stage}
          />
        </Col>
        <Col md={4} xs={12}>
          <DropdownSearch
            name="service"
            label="Service Description"
            onChange={onChange}
            disabled
            data={defaultData?.services?.map((service) => ({
              value: service._id,
              label: service.description
            }))}
            value={inputs?.service}
          />
        </Col>
        <Col md={6} xs={6}>
          <DateTimePicker
            required
            name="arrival_date"
            label="Start Time"
            onChange={onChangeDate}
            value={inputs?.arrival_date}
          />
        </Col>
        <Col md={6} xs={6}>
          <DateTimePicker
            name="completed_date"
            label="End Time"
            onChange={onChangeDate}
            value={inputs?.completed_date}
            disabled
          />
        </Col>
        <Col md={6} xs={12}>
          <Textarea
            required
            formNoValidate
            type="text"
            name="internal_notes"
            label="Internal Notes"
            value={inputs?.internal_notes}
            validations={{ maxLength: 1500 }}
            validationErrors={{
              maxLength: "You can not type in more than 1500 characters"
            }}
            onChange={onChange}
          />
        </Col>
        <Col md={6} xs={12}>
          <Textarea
            formNoValidate
            type="text"
            name="billing_description"
            label="Customer Billing Notes"
            value={inputs?.billing_description}
            validations={{ maxLength: 100 }}
            validationErrors={{
              maxLength: "You can not type in more than 100 characters"
            }}
            onChange={onChange}
          />
        </Col>
        <Col md={2} xs={6}>
          <Checkbox
            formNoValidate
            name="off_hours"
            valueLabel="Off Hours"
            value={inputs?.off_hours}
            disabled
          />
        </Col>
        <Col md={2} xs={6}>
          <Checkbox
            formNoValidate
            name="fixed_time"
            valueLabel="Fixed Time"
            value={inputs?.fixed_time}
            disabled
          />
        </Col>
        <Col md={12} xs={12}>
          <fieldset>
            <legend>Employees</legend>
          </fieldset>
        </Col>
        <Col sm={12}>
          <CustomToggle
            name="individualHoliday"
            label="Assign to specific employee"
            onChange={(e) => toggleIndividualHoliday(e.target.checked)}
            value={individualHoliday}
            checkedIcon={<IoPeople />}
            uncheckedIcon={<IoPerson />}
          />
        </Col>
        {!individualHoliday && (
          <React.Fragment>
            <Col md={11} xs={8}>
              <DropdownSearch
                isMulti
                placeholder="Employment Status"
                label="Employment Status"
                name="status"
                onChange={onChange}
                value={inputs?.status}
                required
                data={defaultData?.status?.map((s) => ({
                  key: s._id,
                  value: s._id,
                  label: s.label
                }))}
              />
            </Col>
            <Col md={1} xs={4}>
              <Button
                style={{ marginTop: "3rem" }}
                className="btn"
                onClick={usersToggle}
              >
                {displayUsers ? (
                  <IoEyeOff className="icon" />
                ) : (
                  <IoEye className="icon" />
                )}
              </Button>
            </Col>
          </React.Fragment>
        )}
      </Row>
      <Row>
        <Col md={12} className="footer">
          <input
            className="btn btn-success"
            type="submit"
            value={saving ? "Adding..." : "Add"}
            disabled={
              !allowSubmit ||
              (!individualHoliday && inputs.status?.length === 0) ||
              (individualHoliday && selectedUsers?.length === 0)
            }
          />
        </Col>
      </Row>
    </Formsy>
  );
};

HolidayForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  defaultData: PropTypes.object,
  onChangeDate: PropTypes.func,
  onSubmit: PropTypes.func,
  saving: PropTypes.bool,
  usersToggle: PropTypes.func,
  displayUsers: PropTypes.bool,
  individualHoliday: PropTypes.bool,
  toggleIndividualHoliday: PropTypes.func,
  selectedUsers: PropTypes.array
};
HolidayForm.defaultProps = {
  inputs: {},
  defaultData: {
    customers: [],
    projects: [],
    call_types: [],
    saving: false,
    displayUsers: false,
    individualHoliday: false,
    toggleIndividualHoliday: () => null,
    selectedUsers: []
  }
};
export default HolidayForm;
